<template>
    <div>
        
        <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Período</label>
                  <b-form-select id="company"
                    v-model="filters.periodId"
                    :plain="true"
                    :options="periodDDL"
                    :value="[null,'c']"
                    @change="changePeriod()"
                    >
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group >
                  <label for="startDate">&nbsp;</label>
                  <b-form-input v-model="filters.startDate" type="date" id="startDate"></b-form-input>
                </b-form-group>
            </b-col>

            <!--
            <b-col cols="auto">
              <b-form-group >
                  <label for="startDate">&nbsp;&nbsp;&nbsp;</label>
                  <b-form-input v-model="filters.endDate" type="date" id="endDate"></b-form-input>
                </b-form-group>
            </b-col>
            -->

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <!--
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            -->
          </b-row>

        <b-row>

            <b-col sm="12" md="6" lg="6" xl="4" v-for="item in monitorData.mainMonitor" :key="item.id">
                <b-card no-body :class="item.monitorClass">
                <b-card-body class="pb-0" style="min-height: 150px">
                    <!--
                    <b-dropdown class="float-right" variant="transparent p-0" right>
                    <template slot="button-content">
                        <i class="icon-settings"></i>
                    </template>
                     <b-dropdown-item @click="$router.push({ path: '/franchise/registration' })">Link</b-dropdown-item> 
                    </b-dropdown>
                    -->
                    <h4 class="mb-0">{{ item.intValue ? item.intValue : "&nbsp;"}}</h4>
                    <h4 class="mb-0" v-show="item.realValue">R$ {{ $utils.numberFormat(item.realValue) }}</h4>
                    <p>{{ item.name.toUpperCase() }}</p>
                </b-card-body>
            
                </b-card>
            </b-col>

        </b-row>
        
        <b-row v-for="item in monitorData.groups" :key="item.id">
            <b-col sm="12" lg="12">
                <div class="brand-card">
                    <div class="brand-card-header" :style="item.backgroundStyle">
                        <h4 :style="item.fontStyle" >{{ item.name }}</h4>                        
                    </div>
                    <div class="brand-card-body" v-for="(monitor,i) in item.monitor" :key="i">
                        <div v-for="mon in monitor" :key="mon.id">
                            <div class="text-value">{{ mon.realValue ? "R$ " + $utils.numberFormat(mon.realValue) : (mon.intValue ? mon.intValue : 0) }}</div>
                            <div class="text-uppercase text-muted small">{{ mon.name.toUpperCase() }}</div>
                        </div>
                    </div>

                    <!--
                    <div>
                        <b-col sm="12" md="6" lg="6" xl="4">
                            <b-card no-body class="bg-primary">
                            <b-card-body class="pb-0" style="min-height: 75px">
                                <b-dropdown class="float-right" variant="transparent p-0" right>
                                <template slot="button-content">
                                    <i class="icon-settings"></i>
                                </template>
                                <b-dropdown-item @click="$router.push({ path: '/franchise/registration' })">Presente</b-dropdown-item>
                                <b-dropdown-item @click="$router.push({ path: '/franchise/registration' })">Não presente</b-dropdown-item>
                                </b-dropdown>
                                <h4 class="mb-0">05/03</h4>
                                <p>Evento Semanal</p>
                            </b-card-body>
                        
                            </b-card>
                        </b-col>
                    </div>
                    -->
                </div>
            </b-col>                      
        </b-row>

    </div>
    
 </template>
 
 
 <script>
 
 import Vue from 'vue'
 import axios from "axios";
 
 export default {
     name: 'intranet',
     components: {
         
     },
     props: {
        companyId: 0
     },
     computed: {
        selectedCompanyId() {
            return this.companyId
        }
    },
    data: function() {
         return {
            periodDDL: [
                { value: 0, text: "Período" },
                { value: 30, text: "30 dias" },
                { value: 60, text: "60 dias" },
                { value: 90, text: "90 dias" },
                { value: 120, text: "120 dias" },
                /*
                { value: 314, text: "1º Trimestre" },
                { value: 324, text: "2º Trimestre" },
                { value: 334, text: "3º Trimestre" },
                { value: 344, text: "4º Trimestre" },
                { value: 612, text: "1º Semestre" },
                { value: 622, text: "2º Semestre" }
                */
            ],
            filters: {
                periodId: 30,
                startDate: null,
                endDate: null
            },
            monitorData: {
            }
         }
     },
     methods: {
        changePeriod() {
            if(this.filters.periodId > 0) {     
                if(this.filters.periodId >=15 && this.filters.periodId <= 120) {
                    // Período de dias
                    this.filters.startDate = this.$utils.dateFormat(this.$utils.addDays(new Date(), -this.filters.periodId))
                    this.filters.endDate = null
                }
                else
                if(this.filters.periodId >= 300 && this.filters.periodId <= 399) {
                    var currentYear = new Date().getFullYear()
                    // Trimestre
                    switch(this.filters.periodId) {
                        case 314:
                            this.filters.startDate = currentYear + "-01-01";
                            this.filters.endDate = currentYear + "-03-31";
                            break;
                        case 324:
                            this.filters.startDate = currentYear + "-04-01";
                            this.filters.endDate = currentYear + "-06-30";
                            break;
                        case 334:
                            this.filters.startDate = currentYear + "-07-01";
                            this.filters.endDate = currentYear + "-09-30";
                            break;
                        case 344:
                            this.filters.startDate = currentYear + "-01-10";
                            this.filters.endDate = currentYear + "-12-31";
                            break;
                    }
                }
                else
                if(this.filters.periodId >= 600 && this.filters.periodId <= 699) {
                    var currentYear = new Date().getFullYear()
                    // Semestral
                    if(this.filters.periodId == 612) {
                        this.filters.startDate = currentYear + "-01-01";
                        this.filters.endDate = currentYear + "-06-30";
                    }
                    else {
                        this.filters.startDate = currentYear + "-07-01";
                        this.filters.endDate = currentYear + "-12-31";
                    }
                }
            }
        },

        async refreshData() {
            var s = this;
            var currentUser = this.$store.state.currentUser

            await axios.get(
                this.$store.state.ws_url + "/franchise/portal/monitor?companyId=" + this.selectedCompanyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ) .then(function(resp) {
                s.monitorData = resp.data.obj
            }).catch(function(error) {
                console.log(error)
            })
        }
     },
     mounted: function() {
        this.changePeriod()
        this.refreshData()
     }
     
 }
 
 </script>
 
 <style scoped>


 </style>
 
